// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__254cn","content":"LayoutSettings_content__14J77"};